module.exports = __webpack_public_path__ + "static/media/click2.882a5158.ogg";